import React from "react";
import { Container } from "react-bootstrap";
import "./not_found.css";
const NotFound = () => {
  return (
    <>
      <Container style={{ marginTop: "60px" }}>
        <div className="not_found">404 Not Found</div>
      </Container>
    </>
  );
};

export default NotFound;
